/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Activity,
  ActivityAssignee,
  ActivityHour,
  ActivityLine,
  ActivitySearchResult,
  AddActivityAssignee200,
  AddActivityAssigneeRequest,
  AddActivityHour200,
  AddActivityHourRequest,
  AddActivityLine200,
  AddActivityLineRequest,
  CreateActivity200,
  CreateActivityRequest,
  DeleteActivity200,
  DeleteActivityHour200,
  DeleteActivityLine200,
  GetActivity200,
  GetActivityHistory200,
  GetActivityHour200,
  GetActivityLine200,
  ListActivitiesParams,
  ListWeekReportActivitiesWithTotalsParams,
  PagedResponseActivitySearchResult,
  RemoveActivityAssignee200,
  SaveActivityHoursRequest,
  SaveActivityLines200,
  SaveActivityLinesRequest,
  SearchActivitiesParams,
  UpdateActivity200,
  UpdateActivityHour200,
  UpdateActivityHourRequest,
  UpdateActivityLine200,
  UpdateActivityLineRequest,
  UpdateActivityRequest
} from '.././models';

import { apiClient } from '../../client';




/**
 * @summary List an activity's realized items
 */
export const listActivityLines = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<ActivityLine[]>(
      {url: `/api/v1/activities/${id}/lines`, method: 'GET', signal
    },
      );
    }
  



export const getListActivityLinesQueryKey = (id?: string,) => {
    return [
    `/api/v1/activities/${id}/lines`
    ] as const;
    }

    
export const getListActivityLinesQueryOptions = <TData = Awaited<ReturnType<typeof listActivityLines>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActivityLines>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListActivityLinesQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listActivityLines>>> = ({ signal }) => listActivityLines(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listActivityLines>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListActivityLinesQueryResult = NonNullable<Awaited<ReturnType<typeof listActivityLines>>>
export type ListActivityLinesQueryError = unknown


export function useListActivityLines<TData = Awaited<ReturnType<typeof listActivityLines>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActivityLines>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listActivityLines>>,
          TError,
          Awaited<ReturnType<typeof listActivityLines>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListActivityLines<TData = Awaited<ReturnType<typeof listActivityLines>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActivityLines>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listActivityLines>>,
          TError,
          Awaited<ReturnType<typeof listActivityLines>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListActivityLines<TData = Awaited<ReturnType<typeof listActivityLines>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActivityLines>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List an activity's realized items
 */

export function useListActivityLines<TData = Awaited<ReturnType<typeof listActivityLines>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActivityLines>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListActivityLinesQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Save removed, updated and added activity lines in one transaction — only while not yet included in a week report
 */
export const saveActivityLines = (
    id: string,
    saveActivityLinesRequest: SaveActivityLinesRequest,
 ) => {
      
      
      return apiClient<SaveActivityLines200>(
      {url: `/api/v1/activities/${id}/lines`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: saveActivityLinesRequest
    },
      );
    }
  


export const getSaveActivityLinesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveActivityLines>>, TError,{id: string;data: SaveActivityLinesRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof saveActivityLines>>, TError,{id: string;data: SaveActivityLinesRequest}, TContext> => {

const mutationKey = ['saveActivityLines'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveActivityLines>>, {id: string;data: SaveActivityLinesRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  saveActivityLines(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SaveActivityLinesMutationResult = NonNullable<Awaited<ReturnType<typeof saveActivityLines>>>
    export type SaveActivityLinesMutationBody = SaveActivityLinesRequest
    export type SaveActivityLinesMutationError = unknown

    /**
 * @summary Save removed, updated and added activity lines in one transaction — only while not yet included in a week report
 */
export const useSaveActivityLines = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveActivityLines>>, TError,{id: string;data: SaveActivityLinesRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveActivityLines>>,
        TError,
        {id: string;data: SaveActivityLinesRequest},
        TContext
      > => {

      const mutationOptions = getSaveActivityLinesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Log realized quantity on an item within this activity
 */
export const addActivityLine = (
    id: string,
    addActivityLineRequest: AddActivityLineRequest,
 signal?: AbortSignal
) => {
      
      
      return apiClient<AddActivityLine200>(
      {url: `/api/v1/activities/${id}/lines`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addActivityLineRequest, signal
    },
      );
    }
  


export const getAddActivityLineMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addActivityLine>>, TError,{id: string;data: AddActivityLineRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof addActivityLine>>, TError,{id: string;data: AddActivityLineRequest}, TContext> => {

const mutationKey = ['addActivityLine'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addActivityLine>>, {id: string;data: AddActivityLineRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  addActivityLine(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddActivityLineMutationResult = NonNullable<Awaited<ReturnType<typeof addActivityLine>>>
    export type AddActivityLineMutationBody = AddActivityLineRequest
    export type AddActivityLineMutationError = unknown

    /**
 * @summary Log realized quantity on an item within this activity
 */
export const useAddActivityLine = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addActivityLine>>, TError,{id: string;data: AddActivityLineRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addActivityLine>>,
        TError,
        {id: string;data: AddActivityLineRequest},
        TContext
      > => {

      const mutationOptions = getAddActivityLineMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary List an activity's logged hours
 */
export const listActivityHours = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<ActivityHour[]>(
      {url: `/api/v1/activities/${id}/hours`, method: 'GET', signal
    },
      );
    }
  



export const getListActivityHoursQueryKey = (id?: string,) => {
    return [
    `/api/v1/activities/${id}/hours`
    ] as const;
    }

    
export const getListActivityHoursQueryOptions = <TData = Awaited<ReturnType<typeof listActivityHours>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActivityHours>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListActivityHoursQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listActivityHours>>> = ({ signal }) => listActivityHours(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listActivityHours>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListActivityHoursQueryResult = NonNullable<Awaited<ReturnType<typeof listActivityHours>>>
export type ListActivityHoursQueryError = unknown


export function useListActivityHours<TData = Awaited<ReturnType<typeof listActivityHours>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActivityHours>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listActivityHours>>,
          TError,
          Awaited<ReturnType<typeof listActivityHours>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListActivityHours<TData = Awaited<ReturnType<typeof listActivityHours>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActivityHours>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listActivityHours>>,
          TError,
          Awaited<ReturnType<typeof listActivityHours>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListActivityHours<TData = Awaited<ReturnType<typeof listActivityHours>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActivityHours>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List an activity's logged hours
 */

export function useListActivityHours<TData = Awaited<ReturnType<typeof listActivityHours>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActivityHours>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListActivityHoursQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Save removed, updated and added hour entries in one transaction — only while not yet included in a week report
 */
export const saveActivityHours = (
    id: string,
    saveActivityHoursRequest: SaveActivityHoursRequest,
 ) => {
      
      
      return apiClient<ActivityHour[]>(
      {url: `/api/v1/activities/${id}/hours`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: saveActivityHoursRequest
    },
      );
    }
  


export const getSaveActivityHoursMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveActivityHours>>, TError,{id: string;data: SaveActivityHoursRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof saveActivityHours>>, TError,{id: string;data: SaveActivityHoursRequest}, TContext> => {

const mutationKey = ['saveActivityHours'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveActivityHours>>, {id: string;data: SaveActivityHoursRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  saveActivityHours(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SaveActivityHoursMutationResult = NonNullable<Awaited<ReturnType<typeof saveActivityHours>>>
    export type SaveActivityHoursMutationBody = SaveActivityHoursRequest
    export type SaveActivityHoursMutationError = unknown

    /**
 * @summary Save removed, updated and added hour entries in one transaction — only while not yet included in a week report
 */
export const useSaveActivityHours = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveActivityHours>>, TError,{id: string;data: SaveActivityHoursRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveActivityHours>>,
        TError,
        {id: string;data: SaveActivityHoursRequest},
        TContext
      > => {

      const mutationOptions = getSaveActivityHoursMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Log a worker's hours within this activity — fully optional, an activity may have none
 */
export const addActivityHour = (
    id: string,
    addActivityHourRequest: AddActivityHourRequest,
 signal?: AbortSignal
) => {
      
      
      return apiClient<AddActivityHour200>(
      {url: `/api/v1/activities/${id}/hours`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addActivityHourRequest, signal
    },
      );
    }
  


export const getAddActivityHourMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addActivityHour>>, TError,{id: string;data: AddActivityHourRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof addActivityHour>>, TError,{id: string;data: AddActivityHourRequest}, TContext> => {

const mutationKey = ['addActivityHour'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addActivityHour>>, {id: string;data: AddActivityHourRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  addActivityHour(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddActivityHourMutationResult = NonNullable<Awaited<ReturnType<typeof addActivityHour>>>
    export type AddActivityHourMutationBody = AddActivityHourRequest
    export type AddActivityHourMutationError = unknown

    /**
 * @summary Log a worker's hours within this activity — fully optional, an activity may have none
 */
export const useAddActivityHour = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addActivityHour>>, TError,{id: string;data: AddActivityHourRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addActivityHour>>,
        TError,
        {id: string;data: AddActivityHourRequest},
        TContext
      > => {

      const mutationOptions = getAddActivityHourMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary List activities for the caller's organisation, optionally filtered by contract or by the week report they were aggregated into
 */
export const listActivities = (
    params?: ListActivitiesParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<Activity[]>(
      {url: `/api/v1/activities`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getListActivitiesQueryKey = (params?: ListActivitiesParams,) => {
    return [
    `/api/v1/activities`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListActivitiesQueryOptions = <TData = Awaited<ReturnType<typeof listActivities>>, TError = unknown>(params?: ListActivitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActivities>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListActivitiesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listActivities>>> = ({ signal }) => listActivities(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listActivities>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListActivitiesQueryResult = NonNullable<Awaited<ReturnType<typeof listActivities>>>
export type ListActivitiesQueryError = unknown


export function useListActivities<TData = Awaited<ReturnType<typeof listActivities>>, TError = unknown>(
 params: undefined |  ListActivitiesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActivities>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listActivities>>,
          TError,
          Awaited<ReturnType<typeof listActivities>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListActivities<TData = Awaited<ReturnType<typeof listActivities>>, TError = unknown>(
 params?: ListActivitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActivities>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listActivities>>,
          TError,
          Awaited<ReturnType<typeof listActivities>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListActivities<TData = Awaited<ReturnType<typeof listActivities>>, TError = unknown>(
 params?: ListActivitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActivities>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List activities for the caller's organisation, optionally filtered by contract or by the week report they were aggregated into
 */

export function useListActivities<TData = Awaited<ReturnType<typeof listActivities>>, TError = unknown>(
 params?: ListActivitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActivities>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListActivitiesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create an activity header for a contract/week, optionally scoped to a work package
 */
export const createActivity = (
    createActivityRequest: CreateActivityRequest,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CreateActivity200>(
      {url: `/api/v1/activities`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createActivityRequest, signal
    },
      );
    }
  


export const getCreateActivityMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createActivity>>, TError,{data: CreateActivityRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createActivity>>, TError,{data: CreateActivityRequest}, TContext> => {

const mutationKey = ['createActivity'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createActivity>>, {data: CreateActivityRequest}> = (props) => {
          const {data} = props ?? {};

          return  createActivity(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateActivityMutationResult = NonNullable<Awaited<ReturnType<typeof createActivity>>>
    export type CreateActivityMutationBody = CreateActivityRequest
    export type CreateActivityMutationError = unknown

    /**
 * @summary Create an activity header for a contract/week, optionally scoped to a work package
 */
export const useCreateActivity = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createActivity>>, TError,{data: CreateActivityRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createActivity>>,
        TError,
        {data: CreateActivityRequest},
        TContext
      > => {

      const mutationOptions = getCreateActivityMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary List executors (teams/individuals) assigned to an activity
 */
export const listActivityAssignees = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<ActivityAssignee[]>(
      {url: `/api/v1/activities/${id}/assignees`, method: 'GET', signal
    },
      );
    }
  



export const getListActivityAssigneesQueryKey = (id?: string,) => {
    return [
    `/api/v1/activities/${id}/assignees`
    ] as const;
    }

    
export const getListActivityAssigneesQueryOptions = <TData = Awaited<ReturnType<typeof listActivityAssignees>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActivityAssignees>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListActivityAssigneesQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listActivityAssignees>>> = ({ signal }) => listActivityAssignees(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listActivityAssignees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListActivityAssigneesQueryResult = NonNullable<Awaited<ReturnType<typeof listActivityAssignees>>>
export type ListActivityAssigneesQueryError = unknown


export function useListActivityAssignees<TData = Awaited<ReturnType<typeof listActivityAssignees>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActivityAssignees>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listActivityAssignees>>,
          TError,
          Awaited<ReturnType<typeof listActivityAssignees>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListActivityAssignees<TData = Awaited<ReturnType<typeof listActivityAssignees>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActivityAssignees>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listActivityAssignees>>,
          TError,
          Awaited<ReturnType<typeof listActivityAssignees>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListActivityAssignees<TData = Awaited<ReturnType<typeof listActivityAssignees>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActivityAssignees>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List executors (teams/individuals) assigned to an activity
 */

export function useListActivityAssignees<TData = Awaited<ReturnType<typeof listActivityAssignees>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActivityAssignees>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListActivityAssigneesQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Assign a team or an individual to an activity — exactly one of teamId/userId
 */
export const addActivityAssignee = (
    id: string,
    addActivityAssigneeRequest: AddActivityAssigneeRequest,
 signal?: AbortSignal
) => {
      
      
      return apiClient<AddActivityAssignee200>(
      {url: `/api/v1/activities/${id}/assignees`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addActivityAssigneeRequest, signal
    },
      );
    }
  


export const getAddActivityAssigneeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addActivityAssignee>>, TError,{id: string;data: AddActivityAssigneeRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof addActivityAssignee>>, TError,{id: string;data: AddActivityAssigneeRequest}, TContext> => {

const mutationKey = ['addActivityAssignee'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addActivityAssignee>>, {id: string;data: AddActivityAssigneeRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  addActivityAssignee(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddActivityAssigneeMutationResult = NonNullable<Awaited<ReturnType<typeof addActivityAssignee>>>
    export type AddActivityAssigneeMutationBody = AddActivityAssigneeRequest
    export type AddActivityAssigneeMutationError = unknown

    /**
 * @summary Assign a team or an individual to an activity — exactly one of teamId/userId
 */
export const useAddActivityAssignee = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addActivityAssignee>>, TError,{id: string;data: AddActivityAssigneeRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addActivityAssignee>>,
        TError,
        {id: string;data: AddActivityAssigneeRequest},
        TContext
      > => {

      const mutationOptions = getAddActivityAssigneeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get a single activity
 */
export const getActivity = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<GetActivity200>(
      {url: `/api/v1/activities/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetActivityQueryKey = (id?: string,) => {
    return [
    `/api/v1/activities/${id}`
    ] as const;
    }

    
export const getGetActivityQueryOptions = <TData = Awaited<ReturnType<typeof getActivity>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivity>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActivityQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActivity>>> = ({ signal }) => getActivity(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActivity>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetActivityQueryResult = NonNullable<Awaited<ReturnType<typeof getActivity>>>
export type GetActivityQueryError = unknown


export function useGetActivity<TData = Awaited<ReturnType<typeof getActivity>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivity>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActivity>>,
          TError,
          Awaited<ReturnType<typeof getActivity>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivity<TData = Awaited<ReturnType<typeof getActivity>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivity>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActivity>>,
          TError,
          Awaited<ReturnType<typeof getActivity>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivity<TData = Awaited<ReturnType<typeof getActivity>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivity>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a single activity
 */

export function useGetActivity<TData = Awaited<ReturnType<typeof getActivity>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivity>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetActivityQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Delete an activity (and its lines/hours) — only while not yet included in a week report
 */
export const deleteActivity = (
    id: string,
 ) => {
      
      
      return apiClient<DeleteActivity200>(
      {url: `/api/v1/activities/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteActivityMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteActivity>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteActivity>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteActivity'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteActivity>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteActivity(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteActivityMutationResult = NonNullable<Awaited<ReturnType<typeof deleteActivity>>>
    
    export type DeleteActivityMutationError = unknown

    /**
 * @summary Delete an activity (and its lines/hours) — only while not yet included in a week report
 */
export const useDeleteActivity = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteActivity>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteActivity>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteActivityMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Update an activity's note — only while not yet included in a week report
 */
export const updateActivity = (
    id: string,
    updateActivityRequest: UpdateActivityRequest,
 ) => {
      
      
      return apiClient<UpdateActivity200>(
      {url: `/api/v1/activities/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateActivityRequest
    },
      );
    }
  


export const getUpdateActivityMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateActivity>>, TError,{id: string;data: UpdateActivityRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateActivity>>, TError,{id: string;data: UpdateActivityRequest}, TContext> => {

const mutationKey = ['updateActivity'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateActivity>>, {id: string;data: UpdateActivityRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  updateActivity(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateActivityMutationResult = NonNullable<Awaited<ReturnType<typeof updateActivity>>>
    export type UpdateActivityMutationBody = UpdateActivityRequest
    export type UpdateActivityMutationError = unknown

    /**
 * @summary Update an activity's note — only while not yet included in a week report
 */
export const useUpdateActivity = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateActivity>>, TError,{id: string;data: UpdateActivityRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateActivity>>,
        TError,
        {id: string;data: UpdateActivityRequest},
        TContext
      > => {

      const mutationOptions = getUpdateActivityMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get a single activity line
 */
export const getActivityLine = (
    id: string,
    lineId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<GetActivityLine200>(
      {url: `/api/v1/activities/${id}/lines/${lineId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetActivityLineQueryKey = (id?: string,
    lineId?: string,) => {
    return [
    `/api/v1/activities/${id}/lines/${lineId}`
    ] as const;
    }

    
export const getGetActivityLineQueryOptions = <TData = Awaited<ReturnType<typeof getActivityLine>>, TError = unknown>(id: string,
    lineId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityLine>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActivityLineQueryKey(id,lineId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActivityLine>>> = ({ signal }) => getActivityLine(id,lineId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id && lineId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActivityLine>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetActivityLineQueryResult = NonNullable<Awaited<ReturnType<typeof getActivityLine>>>
export type GetActivityLineQueryError = unknown


export function useGetActivityLine<TData = Awaited<ReturnType<typeof getActivityLine>>, TError = unknown>(
 id: string,
    lineId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityLine>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActivityLine>>,
          TError,
          Awaited<ReturnType<typeof getActivityLine>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivityLine<TData = Awaited<ReturnType<typeof getActivityLine>>, TError = unknown>(
 id: string,
    lineId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityLine>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActivityLine>>,
          TError,
          Awaited<ReturnType<typeof getActivityLine>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivityLine<TData = Awaited<ReturnType<typeof getActivityLine>>, TError = unknown>(
 id: string,
    lineId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityLine>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a single activity line
 */

export function useGetActivityLine<TData = Awaited<ReturnType<typeof getActivityLine>>, TError = unknown>(
 id: string,
    lineId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityLine>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetActivityLineQueryOptions(id,lineId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Delete an activity line — only while not yet included in a week report
 */
export const deleteActivityLine = (
    id: string,
    lineId: string,
 ) => {
      
      
      return apiClient<DeleteActivityLine200>(
      {url: `/api/v1/activities/${id}/lines/${lineId}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteActivityLineMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteActivityLine>>, TError,{id: string;lineId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteActivityLine>>, TError,{id: string;lineId: string}, TContext> => {

const mutationKey = ['deleteActivityLine'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteActivityLine>>, {id: string;lineId: string}> = (props) => {
          const {id,lineId} = props ?? {};

          return  deleteActivityLine(id,lineId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteActivityLineMutationResult = NonNullable<Awaited<ReturnType<typeof deleteActivityLine>>>
    
    export type DeleteActivityLineMutationError = unknown

    /**
 * @summary Delete an activity line — only while not yet included in a week report
 */
export const useDeleteActivityLine = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteActivityLine>>, TError,{id: string;lineId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteActivityLine>>,
        TError,
        {id: string;lineId: string},
        TContext
      > => {

      const mutationOptions = getDeleteActivityLineMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Update realized quantity — only while not yet included in a week report
 */
export const updateActivityLine = (
    id: string,
    lineId: string,
    updateActivityLineRequest: UpdateActivityLineRequest,
 ) => {
      
      
      return apiClient<UpdateActivityLine200>(
      {url: `/api/v1/activities/${id}/lines/${lineId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateActivityLineRequest
    },
      );
    }
  


export const getUpdateActivityLineMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateActivityLine>>, TError,{id: string;lineId: string;data: UpdateActivityLineRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateActivityLine>>, TError,{id: string;lineId: string;data: UpdateActivityLineRequest}, TContext> => {

const mutationKey = ['updateActivityLine'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateActivityLine>>, {id: string;lineId: string;data: UpdateActivityLineRequest}> = (props) => {
          const {id,lineId,data} = props ?? {};

          return  updateActivityLine(id,lineId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateActivityLineMutationResult = NonNullable<Awaited<ReturnType<typeof updateActivityLine>>>
    export type UpdateActivityLineMutationBody = UpdateActivityLineRequest
    export type UpdateActivityLineMutationError = unknown

    /**
 * @summary Update realized quantity — only while not yet included in a week report
 */
export const useUpdateActivityLine = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateActivityLine>>, TError,{id: string;lineId: string;data: UpdateActivityLineRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateActivityLine>>,
        TError,
        {id: string;lineId: string;data: UpdateActivityLineRequest},
        TContext
      > => {

      const mutationOptions = getUpdateActivityLineMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get a single activity hour entry
 */
export const getActivityHour = (
    id: string,
    hourId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<GetActivityHour200>(
      {url: `/api/v1/activities/${id}/hours/${hourId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetActivityHourQueryKey = (id?: string,
    hourId?: string,) => {
    return [
    `/api/v1/activities/${id}/hours/${hourId}`
    ] as const;
    }

    
export const getGetActivityHourQueryOptions = <TData = Awaited<ReturnType<typeof getActivityHour>>, TError = unknown>(id: string,
    hourId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityHour>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActivityHourQueryKey(id,hourId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActivityHour>>> = ({ signal }) => getActivityHour(id,hourId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id && hourId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActivityHour>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetActivityHourQueryResult = NonNullable<Awaited<ReturnType<typeof getActivityHour>>>
export type GetActivityHourQueryError = unknown


export function useGetActivityHour<TData = Awaited<ReturnType<typeof getActivityHour>>, TError = unknown>(
 id: string,
    hourId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityHour>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActivityHour>>,
          TError,
          Awaited<ReturnType<typeof getActivityHour>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivityHour<TData = Awaited<ReturnType<typeof getActivityHour>>, TError = unknown>(
 id: string,
    hourId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityHour>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActivityHour>>,
          TError,
          Awaited<ReturnType<typeof getActivityHour>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivityHour<TData = Awaited<ReturnType<typeof getActivityHour>>, TError = unknown>(
 id: string,
    hourId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityHour>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a single activity hour entry
 */

export function useGetActivityHour<TData = Awaited<ReturnType<typeof getActivityHour>>, TError = unknown>(
 id: string,
    hourId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityHour>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetActivityHourQueryOptions(id,hourId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Delete an hour entry — only while not yet included in a week report
 */
export const deleteActivityHour = (
    id: string,
    hourId: string,
 ) => {
      
      
      return apiClient<DeleteActivityHour200>(
      {url: `/api/v1/activities/${id}/hours/${hourId}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteActivityHourMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteActivityHour>>, TError,{id: string;hourId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteActivityHour>>, TError,{id: string;hourId: string}, TContext> => {

const mutationKey = ['deleteActivityHour'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteActivityHour>>, {id: string;hourId: string}> = (props) => {
          const {id,hourId} = props ?? {};

          return  deleteActivityHour(id,hourId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteActivityHourMutationResult = NonNullable<Awaited<ReturnType<typeof deleteActivityHour>>>
    
    export type DeleteActivityHourMutationError = unknown

    /**
 * @summary Delete an hour entry — only while not yet included in a week report
 */
export const useDeleteActivityHour = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteActivityHour>>, TError,{id: string;hourId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteActivityHour>>,
        TError,
        {id: string;hourId: string},
        TContext
      > => {

      const mutationOptions = getDeleteActivityHourMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Update hours — only while not yet included in a week report
 */
export const updateActivityHour = (
    id: string,
    hourId: string,
    updateActivityHourRequest: UpdateActivityHourRequest,
 ) => {
      
      
      return apiClient<UpdateActivityHour200>(
      {url: `/api/v1/activities/${id}/hours/${hourId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateActivityHourRequest
    },
      );
    }
  


export const getUpdateActivityHourMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateActivityHour>>, TError,{id: string;hourId: string;data: UpdateActivityHourRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateActivityHour>>, TError,{id: string;hourId: string;data: UpdateActivityHourRequest}, TContext> => {

const mutationKey = ['updateActivityHour'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateActivityHour>>, {id: string;hourId: string;data: UpdateActivityHourRequest}> = (props) => {
          const {id,hourId,data} = props ?? {};

          return  updateActivityHour(id,hourId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateActivityHourMutationResult = NonNullable<Awaited<ReturnType<typeof updateActivityHour>>>
    export type UpdateActivityHourMutationBody = UpdateActivityHourRequest
    export type UpdateActivityHourMutationError = unknown

    /**
 * @summary Update hours — only while not yet included in a week report
 */
export const useUpdateActivityHour = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateActivityHour>>, TError,{id: string;hourId: string;data: UpdateActivityHourRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateActivityHour>>,
        TError,
        {id: string;hourId: string;data: UpdateActivityHourRequest},
        TContext
      > => {

      const mutationOptions = getUpdateActivityHourMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary AUD-01/AUD-02: header change history for this activity (not line/hour changes)
 */
export const getActivityHistory = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<GetActivityHistory200>(
      {url: `/api/v1/activities/${id}/history`, method: 'GET', signal
    },
      );
    }
  



export const getGetActivityHistoryQueryKey = (id?: string,) => {
    return [
    `/api/v1/activities/${id}/history`
    ] as const;
    }

    
export const getGetActivityHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getActivityHistory>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityHistory>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActivityHistoryQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActivityHistory>>> = ({ signal }) => getActivityHistory(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActivityHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetActivityHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getActivityHistory>>>
export type GetActivityHistoryQueryError = unknown


export function useGetActivityHistory<TData = Awaited<ReturnType<typeof getActivityHistory>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActivityHistory>>,
          TError,
          Awaited<ReturnType<typeof getActivityHistory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivityHistory<TData = Awaited<ReturnType<typeof getActivityHistory>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActivityHistory>>,
          TError,
          Awaited<ReturnType<typeof getActivityHistory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivityHistory<TData = Awaited<ReturnType<typeof getActivityHistory>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityHistory>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary AUD-01/AUD-02: header change history for this activity (not line/hour changes)
 */

export function useGetActivityHistory<TData = Awaited<ReturnType<typeof getActivityHistory>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityHistory>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetActivityHistoryQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Activities aggregated into a week report, each with its totalAmount/totalHours
 */
export const listWeekReportActivitiesWithTotals = (
    params: ListWeekReportActivitiesWithTotalsParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<ActivitySearchResult[]>(
      {url: `/api/v1/activities/with-totals`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getListWeekReportActivitiesWithTotalsQueryKey = (params?: ListWeekReportActivitiesWithTotalsParams,) => {
    return [
    `/api/v1/activities/with-totals`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListWeekReportActivitiesWithTotalsQueryOptions = <TData = Awaited<ReturnType<typeof listWeekReportActivitiesWithTotals>>, TError = unknown>(params: ListWeekReportActivitiesWithTotalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWeekReportActivitiesWithTotals>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListWeekReportActivitiesWithTotalsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listWeekReportActivitiesWithTotals>>> = ({ signal }) => listWeekReportActivitiesWithTotals(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listWeekReportActivitiesWithTotals>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListWeekReportActivitiesWithTotalsQueryResult = NonNullable<Awaited<ReturnType<typeof listWeekReportActivitiesWithTotals>>>
export type ListWeekReportActivitiesWithTotalsQueryError = unknown


export function useListWeekReportActivitiesWithTotals<TData = Awaited<ReturnType<typeof listWeekReportActivitiesWithTotals>>, TError = unknown>(
 params: ListWeekReportActivitiesWithTotalsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWeekReportActivitiesWithTotals>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWeekReportActivitiesWithTotals>>,
          TError,
          Awaited<ReturnType<typeof listWeekReportActivitiesWithTotals>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListWeekReportActivitiesWithTotals<TData = Awaited<ReturnType<typeof listWeekReportActivitiesWithTotals>>, TError = unknown>(
 params: ListWeekReportActivitiesWithTotalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWeekReportActivitiesWithTotals>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWeekReportActivitiesWithTotals>>,
          TError,
          Awaited<ReturnType<typeof listWeekReportActivitiesWithTotals>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListWeekReportActivitiesWithTotals<TData = Awaited<ReturnType<typeof listWeekReportActivitiesWithTotals>>, TError = unknown>(
 params: ListWeekReportActivitiesWithTotalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWeekReportActivitiesWithTotals>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Activities aggregated into a week report, each with its totalAmount/totalHours
 */

export function useListWeekReportActivitiesWithTotals<TData = Awaited<ReturnType<typeof listWeekReportActivitiesWithTotals>>, TError = unknown>(
 params: ListWeekReportActivitiesWithTotalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWeekReportActivitiesWithTotals>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListWeekReportActivitiesWithTotalsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Paginated, filterable activity list for the main Activities list page
 */
export const searchActivities = (
    params?: SearchActivitiesParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<PagedResponseActivitySearchResult>(
      {url: `/api/v1/activities/search`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getSearchActivitiesQueryKey = (params?: SearchActivitiesParams,) => {
    return [
    `/api/v1/activities/search`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSearchActivitiesQueryOptions = <TData = Awaited<ReturnType<typeof searchActivities>>, TError = unknown>(params?: SearchActivitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchActivities>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchActivitiesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchActivities>>> = ({ signal }) => searchActivities(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchActivities>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SearchActivitiesQueryResult = NonNullable<Awaited<ReturnType<typeof searchActivities>>>
export type SearchActivitiesQueryError = unknown


export function useSearchActivities<TData = Awaited<ReturnType<typeof searchActivities>>, TError = unknown>(
 params: undefined |  SearchActivitiesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchActivities>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchActivities>>,
          TError,
          Awaited<ReturnType<typeof searchActivities>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchActivities<TData = Awaited<ReturnType<typeof searchActivities>>, TError = unknown>(
 params?: SearchActivitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchActivities>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchActivities>>,
          TError,
          Awaited<ReturnType<typeof searchActivities>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchActivities<TData = Awaited<ReturnType<typeof searchActivities>>, TError = unknown>(
 params?: SearchActivitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchActivities>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Paginated, filterable activity list for the main Activities list page
 */

export function useSearchActivities<TData = Awaited<ReturnType<typeof searchActivities>>, TError = unknown>(
 params?: SearchActivitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchActivities>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchActivitiesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Remove an executor from an activity
 */
export const removeActivityAssignee = (
    id: string,
    assigneeId: string,
 ) => {
      
      
      return apiClient<RemoveActivityAssignee200>(
      {url: `/api/v1/activities/${id}/assignees/${assigneeId}`, method: 'DELETE'
    },
      );
    }
  


export const getRemoveActivityAssigneeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeActivityAssignee>>, TError,{id: string;assigneeId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof removeActivityAssignee>>, TError,{id: string;assigneeId: string}, TContext> => {

const mutationKey = ['removeActivityAssignee'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeActivityAssignee>>, {id: string;assigneeId: string}> = (props) => {
          const {id,assigneeId} = props ?? {};

          return  removeActivityAssignee(id,assigneeId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RemoveActivityAssigneeMutationResult = NonNullable<Awaited<ReturnType<typeof removeActivityAssignee>>>
    
    export type RemoveActivityAssigneeMutationError = unknown

    /**
 * @summary Remove an executor from an activity
 */
export const useRemoveActivityAssignee = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeActivityAssignee>>, TError,{id: string;assigneeId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeActivityAssignee>>,
        TError,
        {id: string;assigneeId: string},
        TContext
      > => {

      const mutationOptions = getRemoveActivityAssigneeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    